import { classNames } from '../lib/classes';

type Props = { class?: string; label?: string };

export function Spinner(props: Props) {
  return (
    <span
      role="status"
      aria-label={props.label ?? 'Loading'}
      class={classNames(
        'inline-block size-4 shrink-0 animate-spin rounded-full border-2 border-tea-300 border-t-tea-700',
        props.class,
      )}
    />
  );
}
